/* eslint-disable */
import axios from "axios";

function loadElement(type, path, params) {
    let el = {}; let done = false;
    const parent = document.head || document.getElementsByTagName("head")[0] || document.body || document.getElementsByTagName("body")[0];
    const isScript = type === "js";
    const noCache = url => {
        let pre = "";

        if (url.indexOf("?") === -1) {
            pre = "?";
        } else if (url.slice(-1) !== "&") {
            pre = "&";
        }
        return `${url + pre}_cdate=${new Date().getTime()}`;
    };
    const removeElement = () => {
        if (parent && el.parentNode) {
            parent.removeChild(el);
        }
    };

    if (isScript) {
        el = document.createElement("script");
        // Object.assign(el, { type: "text/javascript", src: params.cache === false ? noCache(path) : path });
        Object.assign(el, { type: "text/javascript", src: noCache(path) });
        if (params.charset) {
            el.charset = params.charset;
        }
    } else if (type === "css") {
        el = document.createElement("link");
        Object.assign(el, { type: "text/css", rel: "stylesheet", href: params.cache === false ? noCache(path) : path });
    }

    el.async = 1;

    return new Promise((resolve, reject) => {
        el.onload = el.onreadystatechange = function () {
            if (!done && (!this.readyState || this.readyState === "loaded" || this.readyState === "complete")) {
                done = true;

                el.onload = el.onreadystatechange = null;
                if (isScript) { removeElement(); }
                resolve(el);
            }
        };

        el.onerror = function () {
            if (isScript) { removeElement(); }
            reject(el);
        };

        parent.insertBefore(el, parent.lastChild);
    });
}

function loadTemplate(path) {
    const parent = document.body || document.getElementsByTagName("body")[0];
    const noCache = url => {
        let pre = "";

        if (url.indexOf("?") === -1) {
            pre = "?";
        } else if (url.slice(-1) !== "&") {
            pre = "&";
        }
        return `${url + pre}_cdate=${new Date().getTime()}`;
    };

    return new Promise((resolve, reject) => {
        const newPath = noCache(path);
        axios({ url: newPath, method: "GET" })
            .then(({ data = "" }) => {
                let htmlFragment;
                if (DOMParser) {
                    const parser = new DOMParser();
                    htmlFragment = parser.parseFromString(data, "text/html");
                } else {
                    htmlFragment = document.createElement("div");
                    htmlFragment.innerHTML = data;
                }

                Array.from(htmlFragment.getElementsByTagName("script")).forEach(script => {
                    if (script.type === "text/x-template") {
                        parent.appendChild(script);
                    }
                });
                resolve();
            })
            .catch(error => reject(error));
    });
}

function loadFiles(files, params) {
    const htmls = []; let htmlPromises = [];
    const scripts = []; let scriptPromises = [];
    const styles = []; let stylePromises = [];
    const prm = { cache: false, ...params };

    files.forEach(file => {
        let fileType;

        if (file.type) {
            fileType = file.type;
        } else { }

        if (fileType === "js") {
            scripts.push({ path: file.path });
        } else if (fileType === "css") {
            styles.push({ path: file.path });
        } else if (fileType === "html") {
            htmls.push({ path: file.path });
        }
    });

    if (htmls.length) {
        htmlPromises = htmls.map(html => loadTemplate(html.path));
    } else {
        htmlPromises.push(Promise.resolve());
    }

    return new Promise(resolve => {
        Promise.all(htmlPromises).then(() => {
            if (styles.length) {
                stylePromises = styles.map(style => loadElement("css", style.path, prm));
            } else {
                stylePromises.push(Promise.resolve());
            }

            Promise.all(stylePromises).then(() => {
                if (scripts.length) {
                    scriptPromises = scripts.map(script => loadElement("js", script.path, prm));
                } else {
                    scriptPromises.push(Promise.resolve());
                }

                Promise.all(scriptPromises).then(() => {
                    resolve();
                });
            });
        });
    });
}

export { loadElement, loadTemplate, loadFiles };
